import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'
import { ConfigurationLocalAccountingCustomerModalTabIndex, ConfigurationLocalAccountingCustomersModalState, initialConfigurationLocalAccountingCustomersModalState } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal/configuration-local-accounting-billable-clients-modal.model'
import { ConfigurationCustomerResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import { StrictNullable } from '@/shared/types/app.types'
import ConfigurationLocalAccountingBillableClientsModalBasicForm from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-basic-form/configuration-local-accounting-billable-clients-modal-basic-form.vue'
import ConfigurationLocalAccountingBillableClientsModalContactInformation from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-contact-information/configuration-local-accounting-billable-clients-modal-contact-information.vue'
import ConfigurationLocalAccountingBillableClientsModalRules from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.vue'
import ConfigurationLocalAccountingBillableClientsModalRates from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rates/configuration-local-accounting-billable-clients-modal-rates-grid.vue'

@Component({
    components: {
        ConfigurationLocalAccountingBillableClientsModalBasicForm,
        ConfigurationLocalAccountingBillableClientsModalContactInformation,
        ConfigurationLocalAccountingBillableClientsModalRules,
        ConfigurationLocalAccountingBillableClientsModalRates
    }
})
export default class ConfigurationLocalAccountingBillableClientsModal extends Vue {
    @Ref() readonly clientModal!: BModal
    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    state: ConfigurationLocalAccountingCustomersModalState
    constructor() {
        super()
        this.state = initialConfigurationLocalAccountingCustomersModalState()
    }

    get isClientDisabled(): boolean {
        return !this.state.client?.id
    }

    get customer(): StrictNullable<ConfigurationCustomerResponse> {
        return this.state.client
    }

    async show(client: StrictNullable<ConfigurationCustomerResponse>): Promise<void> {
        await this.$validator.reset()
        if (client) {
            this.state.client = client
        } else {
            this.state.client = null
        }
        this.state.actionTitle = this.actionTitle
        this.clientModal.show()
    }

    hide(): void {
        this.clientModal.hide()
    }

    onCreateClient(createdClient: StrictNullable<ConfigurationCustomerResponse>): void {
        this.state.client = createdClient
        this.create() // emits an event

        // wait for the DOM update (when Concepts tab is active)
        this.$nextTick(() => {
            this.state.actionTitle = this.$tc('configuration.actions.update')
            this.state.activeTabIndex = ConfigurationLocalAccountingCustomerModalTabIndex.CONTACT_DATA
        })
    }

    onUpdateClient() {
        this.update() // emits an event
    }
}
